
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: ["svg svg-step-check",classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 42 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M.482 17.6c-.322-.32-.483-.8-.483-1.12s.161-.8.483-1.12l2.253-2.24c.644-.64 1.609-.64 2.253 0l.161.16 8.852 9.44c.322.32.805.32 1.127 0L36.694.481h.161c.644-.64 1.609-.64 2.253 0l2.253 2.24c.644.64.644 1.6 0 2.24L15.611 31.52c-.322.32-.644.48-1.127.48s-.805-.16-1.127-.48L.804 18.081l-.322-.48z"}})])
          )
        }
      }
    